import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e9ba557"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-add" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex remove-bg-switch"
}
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "remove-bg-switch__text" }

import { PropType, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useEventBus } from '@vueuse/core';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';
import AiFileUpload from '@/components/UI/AiFileUpload/AiFileUpload.vue';

const maxFileSize = 5 * 1024 * 1024;


export default /*#__PURE__*/_defineComponent({
  __name: 'AddImage',
  props: {
  isRemoveBg: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const { t } = useI18n();

const busError = useEventBus<string>('toast-error');

const { currentService } = storeToRefs(useCommonStore());

const { generateImage } = useServicesStore();

const { imageForActions, loading, sourceBgImage } = storeToRefs(useServicesStore());

const key = ref<number>(0);
const fileForUpload = ref<File>();
const removeBg = ref<boolean>(true);

const uploadFile = async (file: File): Promise<void> => {
  if (!file.type.match('image.(jpeg|png|webp)')) {
    busError.emit(t('editor.add-product.err-msg-pls-select-img'));
    fileForUpload.value = undefined;
    return;
  }
  if (file.size > maxFileSize) {
    busError.emit(t('editor.add-product.err-msg-pls-select-small-img'));
    fileForUpload.value = undefined;
    return;
  }
  loading.value = true;
  const reader = new FileReader();
  reader.onload = async (e: any) => {
    const image = e.target.result;

    if ((props.isRemoveBg && removeBg.value) || currentService.value === 'remove_background') {
      const res = await generateImage({
        action: 'remove_background',
        image: removeBase64Prefix(image),
        params: {},
      });

      imageForActions.value = `data:image/png;base64,${res.payload.notTrimmedImage}`;

      if (currentService.value === 'remove_background' || currentService.value === 'create_background_for_image') {
        sourceBgImage.value = image;
      }
    } else {
      imageForActions.value = image;
    }
    fileForUpload.value = undefined;
    key.value += 1;
    loading.value = false;
  };
  reader.readAsDataURL(file);
};

watch(fileForUpload, (newVal) => {
  if (!newVal) {
    return;
  }
  uploadFile(newVal);
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AiCard, {
      class: "service-add__card",
      radius: 16
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          style: _normalizeStyle([{"position":"relative"}, {height: props.isRemoveBg ? 'calc(100% - 56px)' : '100%'}])
        }, [
          (_unref(loading))
            ? (_openBlock(), _createBlock(AiDropLoader, { key: 0 }))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(AiFileUpload, {
            key: key.value,
            class: "service-add__input mb-4",
            title: _ctx.$t('services.add.file-input-title'),
            description: _ctx.$t('services.add.file-input-description'),
            modelValue: fileForUpload.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileForUpload).value = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(AiButton, {
                theme: "gradient-primary",
                style: {"margin":"16px auto 0","display":"block"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('services.add.upload-from-pc')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title", "description", "modelValue"]))
        ], 4),
        (props.isRemoveBg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('editor.add-product.remove-bg-switch')), 1),
                _createVNode(_component_v_switch, {
                  modelValue: removeBg.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((removeBg).value = $event)),
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})